import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=46058350&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=ts&"
export * from "./Help.vue?vue&type=script&lang=ts&"
import style0 from "./Help.vue?vue&type=style&index=0&id=46058350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46058350",
  null
  
)

export default component.exports